import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { MainLayout } from '../../components/layouts/main-layout';
import { PublicPage } from '../base/public-page';
import { LoginComponent } from './login-component';
import { onSuccessLogin } from '../../utils';
import { useUser } from '../../contexts/user-context';
import { logUserEvent } from '../../api/actions/log-user-event';

export function LoginPage(props: RouteComponentProps) {
  const { setUser } = useUser();

  const handleSuccessLogin = async (configurationFinished: boolean) => {
    await onSuccessLogin(configurationFinished, props.history, setUser);
    
    // Log user login event
    /*try {
      await logUserEvent({
        eventType: 'login',
        platform: 'web',
        timestamp: new Date().toISOString(),
      });
    } catch (error) {
      // Log error but don't fail the login process
      console.warn('Failed to log user event:', error);
    }*/
  };

  return (
    <PublicPage pageName="login">
      <MainLayout>
        <LoginComponent onSuccessLogin={handleSuccessLogin} />
      </MainLayout>
    </PublicPage>
  );
}
